const translations = {
    inputSearch: {
        type: 'text',
        defaultValue: 'Jakiego kierunku rozwoju szukasz?',
    },
    selectCategories: {
        type: 'text',
        defaultValue: 'Wszystkie kategorie',
    },
    courseCtaButton: {
        type: 'text',
        defaultValue: 'Zapisz się',
    },
    alreadyScheduledButton: {
        type: 'text',
        defaultValue: 'Jesteś zapisany',
    },
    emptyResultsTextOne: {
        type: 'text',
        defaultValue: 'Zmień kryteria wyszukiwania lub',
    },
    emptyResultsButton: {
        type: 'text',
        defaultValue: ' wyczyść filtry ',
    },
    emptyResultsTextTwo: {
        type: 'text',
        defaultValue: 'aktualnie ustawione.',
    },
    emptyResultsInfo: {
        type: 'text',
        defaultValue: 'Brak wyników dla wybranych filtrów',
    },
};

export default translations;
